import { jsx as i } from "react/jsx-runtime";
import m from "@mui/material/SvgIcon";
import * as o from "react";
import { forwardRef as s } from "react";
const h = (e) => /* @__PURE__ */ o.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "none", viewBox: "7 6 18 20", ...e }, /* @__PURE__ */ o.createElement("path", { fill: "currentColor", d: "M7 10.413c0 .535.449.968 1.004.968h.536v11.432c0 1.761 1.48 3.187 3.302 3.187h8.317c1.82 0 3.3-1.426 3.3-3.187V11.38h.537c.555 0 1.004-.433 1.004-.968 0-.536-.449-.968-1.005-.968H20.48v-1C20.48 7.097 19.34 6 17.942 6h-3.884c-1.4 0-2.538 1.097-2.538 2.445v1H8.004c-.555 0-1.004.432-1.004.968m12.502 3.716v7.187c0 .536-.448.968-1.004.968s-1.005-.432-1.005-.968V14.13c0-.535.449-.968 1.005-.968s1.004.433 1.004.968M13.53 8.445c0-.284.234-.51.529-.51h3.884c.295 0 .529.226.529.51v1h-4.942zm-1.031 5.684c0-.535.448-.968 1.004-.968s1.005.433 1.005.968v7.187c0 .536-.449.968-1.005.968s-1.004-.432-1.004-.968z" })), f = /* @__PURE__ */ s(({ size: e = "inherit", sx: t, ...c }, r) => {
  const n = typeof t == "function" ? t : {
    fontSize: e,
    ...t
  };
  return /* @__PURE__ */ i(m, {
    ...c,
    ref: r,
    component: h,
    inheritViewBox: !0,
    sx: n
  });
});
f.displayName = "svg_delete";
export {
  f as default
};
